module.exports = __webpack_public_path__ + "img/sunrise.53beb04a.svg";